import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-asset-reviews',
  templateUrl: './asset-reviews.component.html',
  styleUrls: ['./asset-reviews.component.scss']
})

export class AssetReviewsComponent implements OnInit {
  @Input() commentList: any = [];
  @Input() totalRatingSum : number = 0;
  @Input() avg_rating : number = 0;
  @Input() ratingList : any;
  @Input() filledRatingStars: any = 0;
  @Input() unfilledRatingStars: any = 0;
  commentListCount: any = 0;
  seeMoreValue : boolean;
  
  constructor() { }
  ngOnInit(): void {
    if(this.commentList != null){
    this.commentListCount = this.commentList.length;
    this.commentList.sort(function(a:any,b:any){
      return new Date(b.Updated_On).valueOf() - new Date(a.Updated_On).valueOf();
    });
    }
  }
    
  

}
